import { animate, state, style, transition, trigger, AnimationTriggerMetadata } from '@angular/animations';

/**
 * Animation that toggles visibility with height and opacity
 */
export const inputErrorAnimation = trigger('inputErrorAnimation', [
  state('true', style({
    opacity: 1,
  })),
  state('false', style({
    opacity: 0,
    height: '0px',
  })),
  transition('false => true', [animate('300ms')]),
  transition('true => false', [animate('300ms')]),
])
